import * as React from "react";
import {useEffect, useState} from "react";
import {MeetingNoteSummary} from "../../../model/MeetingNoteSummary.model";
import {MeetingNotesApi} from "../../../api/MeetingNotesApi";
import {formatShortDate} from "../../../utils/dateUtil";
import {DialogComponent} from "../../common/Dialog.component";
import {Link} from "react-router-dom";
import {getLocationOrigin} from "../../../api/BrowserWrapper";
import {LoadingSpinner} from "../../icons/LoadingSpinner.component";
import {useDispatch} from "react-redux";
import {setHeaderNotification} from "../../base/header/HeaderActions";
import {NotificationTypes} from "../../base/header/HeaderReducer";
import {scrollToElement} from "../../../utils/browserUtil";
import {AnyThunkDispatch} from "../../../../commonTypes";

export const MEETING_NOTE_DIALOG_TITLE = "Request Meeting Summary";
export const MEETING_NOTE_DIALOG_BODY = "A request for a meeting summary will be sent to the Investment Manager Research team. You will receive an email with the summary within approximately 1 week.";
export const MEETING_NOTE_CHECK_BACK_SOON = "Check back soon for summary";

export interface IProductMeetingNoteProps {
    productBackstopId: number;
}
export const ProductMeetingNote: React.FunctionComponent<IProductMeetingNoteProps> = (props) => {
    const [meetingNote, setMeetingNote] = useState<MeetingNoteSummary | undefined>(undefined);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const dispatch: AnyThunkDispatch = useDispatch();

    const getLatestMeetingNote = () => {
        MeetingNotesApi.requestLatestMeetingNoteForProduct(props.productBackstopId)
            .then ((response) => {
                setMeetingNote(response);
            })
            .catch(() => {
                setMeetingNote(undefined);
            });
    };

    useEffect(() => {
        getLatestMeetingNote();
    }, [props]);

    const handleClose = () => {
        setDialogOpen(false);
    };

    const handleRequestSummary = () => {
        setDialogOpen(false);
        setLoading(true);
        MeetingNotesApi.createMeetingNoteSummaryRequest(
            props.productBackstopId, meetingNote!.backstopId, getLocationOrigin()
        )
            .then (() => {
                getLatestMeetingNote();
                setLoading(false);
                dispatch(setHeaderNotification({
                    message: "The request has been sent",
                    notificationType: NotificationTypes.SUCCESS,
                }, 5000));
                scrollToElement(".main__header", 0);
            })
            .catch(() => {
                setLoading(false);
                dispatch(setHeaderNotification({
                    message: "There was an error in the request.  Please try again.",
                    notificationType: NotificationTypes.FAILURE,
                }, 5000));
                scrollToElement(".main__header", 0);
            });
    };

    const renderDialog = () => {
        return <DialogComponent
            title={MEETING_NOTE_DIALOG_TITLE}
            open={dialogOpen}
            description={MEETING_NOTE_DIALOG_BODY}
            noText={"Cancel"}
            yesText={"Request"}
            onNo={handleClose}
            onYes={handleRequestSummary}
        />;
    };

    const renderLink = meetingNote?.isExternal
     ? <Link to={`/products/${props.productBackstopId}/meeting-note`}
                    className="link-14">
            View Summary
        </Link>
        : meetingNote?.requested
            ? <span>{MEETING_NOTE_CHECK_BACK_SOON}</span>
            : <a className="link-14 clickable" onClick={() => setDialogOpen(true)}>Request Summary</a>;

    const renderMeetingNoteInfo = loading
    ?  <LoadingSpinner/>
        : meetingNote && <div>
                <div>
                    <div className="meeting-note__title">{meetingNote.title}</div>
                    <div className="meeting-note__date date-12">{formatShortDate(meetingNote.date)}</div>
                    <div className="meeting-note__text">
                        {renderLink}
                    </div>
                </div>
                {renderDialog()}
            </div>;

    return meetingNote
        ? <div className="product__documents" data-testid="product__meeting-note-container">
                <h2>
                    Manager Meeting
                </h2>
                {renderMeetingNoteInfo}
            </div>
        : null;
};